import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth.component';
import { ForgotComponent } from './forgot/forgot.component';
import { LoginComponent } from './login/login.component';
import { ResetComponent } from './reset/reset.component';
import { WelcomeComponent } from './welcome/welcome.component';

const routes: Routes = [{
    path: '',
    component: AuthComponent,
    children: [{
        path: '',
        component: LoginComponent,
    },
    {
        path: 'forgot',
        component: ForgotComponent,
    },
    {
        path: 'reset/:hash',
        component: ResetComponent,
    },
    {
        path: 'welcome/:hash',
        component: WelcomeComponent,
    }]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }
